import ChainRatesInfo from './ChainRatesInfo';

export default ChainRatesInfo;
